/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockRecipeListCtrl
 */
angular.module('mercury.modules.stock.recipe')
.controller('StockRecipeListCtrl', ["dialog", "$scope", "$filter", "StockRecipes", "title", "userinfo", function(dialog, $scope, $filter, StockRecipes, title, userinfo) {
  title.set('Manage Stock Recipes');

  $scope.filter = {name: '', datestampDeleted: null};

  window.onafterprint = function() {
    $('.print-spinner', window.parent.document).removeClass('open');
    $('.print-embed', window.parent.document).remove();
  };

  $scope.filteredRecipes = [];

  $scope.checkedRecipes = {};

  $scope.recipes = StockRecipes.getAll();
  $scope.recipes.$promise.then(function() {
    $scope.updateFilter();
  });

  $scope.stockSharePermission = userinfo.companyHasPermission('StockShare');

  /**
  * Callback for changing the search string or 'Show Deleted' checkbox. Update the filtered recipes to be shown.
  */
  $scope.updateFilter = function() {
    $scope.filteredRecipes = $filter('filter')($scope.recipes, $scope.filter);
  };

  /**
  * Mark the specifiedactive recipe as deleted on the server, then update the local model.
  *
  * @param {Object} recipe - The recipe to mark as deleted
  */
  $scope.removeRecipe = function(recipe) {
    if (recipe.isShared && !$scope.stockSharePermission) {
      dialog.alert('This recipe has been shared with other companies and cannot be deleted without \'Stock Sharing\' permission.');
    } else {
      StockRecipes.remove(recipe)
      .then(function() {
        recipe.datestampDeleted = moment().format();
        recipe.datestampModified = moment().format();
        $scope.updateFilter();
      });
    }
  };

  /**
  * Mark the specified deleted recipe as active on the server, then update the local model.
  *
  * @param {Object} recipe - The recipe to mark as active
  */
  $scope.restoreRecipe = function(recipe) {
    StockRecipes.restore(recipe)
    .then(function() {
      recipe.datestampDeleted = null;
      recipe.datestampModified = moment().format();
      $scope.updateFilter();
    });
  };

  /*
   * Event called when an item from the current company is updated from the manage share dialog.
   */
  $scope.$on('manageSharedRecipeUpdated', function(event, updatedRecipe) {
    angular.forEach($scope.recipes, function(recipe) {
      if (recipe.id == updatedRecipe.id) {
        recipe = angular.extend(recipe, updatedRecipe);

        if (recipe.datestampDeleted) {
          $scope.updateFilter();
        }
      }
    });
  });

  $scope.shareRecipe = function(recipe) {
    dialog.open({
      templateUrl: 'modules/stock/recipe/share.tpl.html',
      controller: 'StockRecipeShareCtrl',
      resolve: {
        recipeIds: function() {
          return [recipe.id];
        },
        companyId: function() {
          return null;
        }
      }
    });
  };

  $scope.manageShare = function(recipe) {
    dialog.open({
      templateUrl: 'modules/stock/recipe/manageshare.tpl.html',
      controller: 'StockRecipeManageShareCtrl',
      resolve: {
        recipeId: function() {
          return recipe.id;
        }
      }
    });
  };

  $scope.checkAll = function(state) {
    $scope.checkedRecipes = {};
    angular.forEach($scope.recipes, function(recipe) {
      if (!recipe.datestampDeleted) {
        $scope.checkedRecipes[recipe.id] = state;
      }
    });
  };

  $scope.cancelShare = function() {
    $scope.shareMode = false;
    $scope.checkedRecipes = {};
  };

  var bulkShare = function(recipeIds) {
    dialog.open({
      templateUrl: 'modules/stock/recipe/share.tpl.html',
      controller: 'StockRecipeShareCtrl',
      resolve: {
        recipeIds: function() {
          return recipeIds;
        },
        companyId: function() {
          return null;
        }
      }
    });
  };

  $scope.newPrint = function(id) {
    jQuery('.print-spinner[data-id="' + id + '"]').addClass('open');

    $('<iframe class="print-embed">')                             // create a new iframe element
    .css({'width': '1px', 'height': '1px', 'opacity': '0'})                            // make it invisible
    .attr('src', '/App/#/stock/recipes/view/' + id + '?print=true') // point the iframe to the page you want to print
    .appendTo('body');
  };

  $scope.shareSelected = function() {
    var selected = [];
    angular.forEach($scope.checkedRecipes, function(isChecked, recipeId) {
      if (isChecked) {
        selected.push(recipeId);
      }
    });

    if (selected.length === 0) {
      dialog.alert('Please select recipes to share using the checkboxes beside the recipe names.');
      return;
    }

    bulkShare(selected);

    $scope.cancelShare();
  };

  $scope.shareAll = function() {
    var recipeIds = [];
    angular.forEach($scope.recipes, function(recipe) {
      if (!recipe.datestampDeleted) {
        recipeIds.push(recipe.id);
      }
    });

    bulkShare(recipeIds);

    $scope.cancelShare();
  };
}]);
